import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Icon } from '@lomarengas/design-system';
import {
  DataTable,
  DataTableItem,
  PaginationComponent,
  SearchBar,
  SectionHeader,
} from '../../common/components';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  getRegionsAsync,
  selectRegionItems,
  RegionsFilter,
  selectRegionItemsPagination,
  selectRegionItemsLoadingStatus,
} from './regionsSlice';
import { LOADING_STATUS } from '../../common/constants';
import { InitialPaginationParameters } from '../../common/types/pagination.types';

function Regions() {
  const dispatch = useAppDispatch();
  const regionItems = useAppSelector(selectRegionItems);
  const regionItemsPagination = useAppSelector(selectRegionItemsPagination);
  const regionItemsLoadingStatus = useAppSelector(
    selectRegionItemsLoadingStatus,
  );

  const initialRegionsFilter: RegionsFilter = {
    PageNumber: InitialPaginationParameters.PageNumber,
    PageSize: InitialPaginationParameters.PageSize,
    searchString: '',
  };

  const [regionsFilter, setRegionsFilter] = useState(initialRegionsFilter);
  const [regionTableItems, setRegionTableItems] = useState<DataTableItem[]>([]);

  const handleInputChange = event => {
    const { target } = event;
    const { value, name } = target;
    setRegionsFilter({ ...regionsFilter, [name]: value });
  };

  const doSearch = () => {
    regionsFilter.PageNumber = InitialPaginationParameters.PageNumber;
    dispatch(getRegionsAsync(regionsFilter));
  };

  const HandlePaginationClick = (Page: number) => {
    const paginatedFiltering = regionsFilter;
    paginatedFiltering.PageNumber = Page;
    setRegionsFilter(paginatedFiltering);
    dispatch(getRegionsAsync(paginatedFiltering));
  };

  useEffect(() => {
    doSearch();
  }, []);

  useEffect(() => {
    if (regionItems && regionItems.length > 0) {
      const formattedRegionItemsList: DataTableItem[] = [];
      regionItems?.forEach(item => {
        formattedRegionItemsList.push({
          ItemId: item.id,
          Items: [item.id, item.name],
          Url: `/locations/regions/${item.id}`,
        });
      });
      setRegionTableItems(formattedRegionItemsList);
    }
  }, [regionItems]);

  const AddNewButton: JSX.Element = (
    <Link to="/locations/regions/addnew" className="btn btn-blue ps-16">
      <Icon CssClass="me-8" AriaLabel="Uusi" Name="plus" />
      Lisää uusi
    </Link>
  );

  return (
    <>
      <Helmet>
        <title>Sijaintitiedot - Alueet - Haku</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          Breadcrumbs={['Sijaintitiedot']}
          Children={AddNewButton}
          Title="Alueet"
        />

        <SearchBar
          FreeTextOnChangeHandler={handleInputChange}
          FreeTextPlaceholder="Hae..."
          SearchHandler={doSearch}
          IsLoading={regionItemsLoadingStatus !== LOADING_STATUS.IDLE}
          Value={regionsFilter.searchString}
        />

        {regionItemsLoadingStatus === LOADING_STATUS.IDLE &&
          regionItems !== null &&
          regionItems.length > 0 && (
            <>
              <DataTable
                ColumnWidths={[400, null]}
                Header={['Alueen ID', 'Alueen nimi']}
                Items={regionTableItems}
                LegendText="aluetta"
                TotalItems={regionItemsPagination.totalCount}
              />
              <PaginationComponent
                OnPageClick={HandlePaginationClick}
                PaginationData={regionItemsPagination}
              />
            </>
          )}

        {regionItemsLoadingStatus === LOADING_STATUS.IDLE &&
          regionItems != null &&
          regionItems.length < 1 && <p>Ei alueita annetuilla hakuehdoilla.</p>}
      </Container>
    </>
  );
}

export default Regions;
